import type { TotemEnv } from '../types/totem-env';
const env = window.__TOTENV__ as TotemEnv;

export const isProduction = env.ENV === 'prod';
export const isPreprod = env.ENV === 'preprod';
export const isDemo = env.ENV === 'demo';
export const rawUrl = env.RAW_URL;

// API_TLS l'emporte : la préprod ouverte par le connecteur navigateur (kube/mcp-browser) joint l'API par son Service,
// en HTTP (cf. public/configuration.prod.js).
function isApiTls(): boolean {
    return env.API_TLS ?? (isProduction || isPreprod || isDemo);
}

export function formGraphQLUrl(isWS: boolean): string {
    if (!env) {
        throw Error('Unhandled __TOTENV__');
    }
    const protocol = isWS ? (isApiTls() ? 'wss://' : 'ws://') : isApiTls() ? 'https://' : 'http://';

    // All cases return the same string, so simplify:
    return `${protocol}${rawUrl}/graphql`;
}

export function formApiUrl(): string {
    if (!env) {
        throw Error('Unhandled __TOTENV__');
    }
    const protocol = isApiTls() ? 'https://' : 'http://';
    return `${protocol}${rawUrl}`;
}
